import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const TitleWrapper = styled.div`
  width: calc(100% - 60px);
  margin-bottom: 16px;

  ${mediaQueries.tablet} {
    width: 360px;
  }
`
